import React from 'react'
import { useNavigate } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { ErrorBoundary } from '../../../components/common/ErrorBoundary'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { BackButton } from '../../../components/common/BackButton'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'
import { ErrorView } from '../../error/ErrorView'
import { IllustrationChoices } from '../../../components/common/Illustration'
import { ButtonVariant } from '../../../components/common/Button'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { i18nSocietyType } from '../../../i18n'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'

export const NewSocietyView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  useDocumentTitle(reverseDocumentTitle('new-society'))
  const navigate = useNavigate()

  const goBack = (): void => {
    navigate(-1)
  }

  return (
    <ErrorBoundary>
      <div className="h-full w-full p-6">
        <div className="flex items-center space-x-4">
          <BackButton onClick={goBack} />
          <p style={theme.textVariants.h2}>
            {translate('newSocietyView.title', {
              context: i18nSocietyType(society?.societyTypeDisplayName),
            })}
          </p>
        </div>

        <ErrorView
          title={translate('feedView.emptyState.noSociety.subtitle')}
          illustration={IllustrationChoices.BUILDINGS}
          buttonClassName="flex-1"
          buttons={[
            {
              id: uuid(),
              button: {
                label: translate('feedView.emptyState.noSociety.buttonTitle', {
                  context: i18nSocietyType(society?.societyTypeDisplayName),
                }),
                onClick: () => navigate(reverseUrl('find-society')),
                variant: ButtonVariant.DEFAULT,
              },
            },
            {
              id: uuid(),

              button: {
                label: translate(
                  'feedView.emptyState.noSociety.createSocietyButton',
                  { context: i18nSocietyType(society?.societyTypeDisplayName) }
                ),
                onClick: () => navigate(reverseUrl('create-society:pick-type')),
                variant: ButtonVariant.PRIMARY,
              },
            },
          ]}
        />
      </div>
    </ErrorBoundary>
  )
}
